export enum VoucherTypeEnum {
    DP = 'DP',
    ORP = 'ORP',
    FT = 'FT',
}
